/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterConfirmDraftResponse,
  PresenterConfirmSummaryResponse,
  PresenterDraftFixedAssetResponse,
  PresenterError,
  PresenterIDResponse,
  PresenterPreFillDraftAssetRequest,
  PresenterPreFillDraftAssetResponse,
  PresenterResponse,
  PresenterUpsertDraftFixedAssetRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DraftAssets<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Reflects all 台帳未反映 / 台帳削除 drafts as registered fixed assets and finalizes all 未確定 expenses. A failed item does not block the others. When any item fails the response is 422: data still lists what was confirmed, plus failed_items / failed_expenses with each item's translated errors (a duplicated asset code carries attributes.duplicated_asset of the conflicting asset), and errors[] holds one translated toast per failure reason, with attributes {reason_code, asset_count, expense_count, draft_ids, expense_ids}. failed_items / failed_expenses are omitted when that side has no failures.
   *
   * @tags draft_assets
   * @name PostSuspenseAccountConfirm
   * @summary Confirm all draft assets (台帳反映・費用確定)
   * @request POST:/suspense_account/confirm
   */
  postSuspenseAccountConfirm = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterConfirmDraftResponse;
      },
      | PresenterError
      | (PresenterResponse & {
          data?: PresenterConfirmDraftResponse;
        })
    >({
      path: `/suspense_account/confirm`,
      method: "POST",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns the office's still-unconfirmed draft-asset count (台帳未反映 and 台帳削除, both of which 確定 re-reflects) and 未確定 expense count — the two quantities POST /suspense_account/confirm would act on. Both are office-wide and term-month-blind, matching that endpoint's own scope. draft_asset_unconfirmed_count is the same number the draft list returns as meta.total_unreflect.
   *
   * @tags draft_assets
   * @name GetSuspenseAccountConfirmSummary
   * @summary Counts for the 資産化・費用化を確定 confirmation dialog
   * @request GET:/suspense_account/confirm_summary
   */
  getSuspenseAccountConfirmSummary = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterConfirmSummaryResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/confirm_summary`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a staging draft from one or more AccPlus journal sides.
   *
   * @tags draft_assets
   * @name PostSuspenseAccountDraftAssets
   * @summary Create a new DraftFixedAsset
   * @request POST:/suspense_account/draft_assets
   */
  postSuspenseAccountDraftAssets = (
    body: PresenterUpsertDraftFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDraftFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Given a list of (side_id, amount) allocations, returns server-computed
   *
   * @tags draft_assets
   * @name PostSuspenseAccountDraftAssetsPreFill
   * @summary Pre-fill basic info from journal sides
   * @request POST:/suspense_account/draft_assets/pre_fill
   */
  postSuspenseAccountDraftAssetsPreFill = (
    body: PresenterPreFillDraftAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterPreFillDraftAssetResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets/pre_fill`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Updates Basic Info, ledgers, and the linked allocation set of an existing draft.
   *
   * @tags draft_assets
   * @name PutSuspenseAccountDraftAssetsById
   * @summary Update a DraftFixedAsset
   * @request PUT:/suspense_account/draft_assets/{id}
   */
  putSuspenseAccountDraftAssetsById = (
    id: number,
    body: PresenterUpsertDraftFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDraftFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets/${id}`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Hard-deletes a NotReflected draft and reverts its journal-side allocated values.
   *
   * @tags draft_assets
   * @name DeleteSuspenseAccountDraftAssetsById
   * @summary Delete a DraftFixedAsset
   * @request DELETE:/suspense_account/draft_assets/{id}
   */
  deleteSuspenseAccountDraftAssetsById = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/suspense_account/draft_assets/${id}`,
      method: "DELETE",
      ...params,
    });
}
